<template>
    <div
        :class="
            'site-struct ' +
            (isGalleryPage
                ? 'full galleries-struct2 '
                : paid === null || paid === true || err
                ? 'single'
                : (getInfos && getInfos.terminal) || isTerminalMode
                ? 'single'
                : 'single')
        ">
        <LoadingStruct
            :is-loading="loading || !this.getInfos || !this.getInfos.articles">
            <div v-if="isGalleryPage" class="total-struct uk-padding">
                <div class="uk-grid" uk-grid>
                    <div class="uk-flex uk-flex-middle">
                        <div>
                            <LinkObject to="">
                                <img
                                    v-if="getInfos.logo"
                                    :alt="getInfos.name"
                                    :src="apiUrl + '/logos/' + getInfos.logo"
                                    class="logo infos-name" />
                                <span class="iname uk-visible@m">
                                    {{ getInfos.name }}
                                </span>
                            </LinkObject>
                        </div>

                        <div class="uk-width-expand uk-invisible" />
                        <div class="uk-flex uk-flex-middle uk-invisible">
                            <span class="gallery-name">
                                {{ getInfos.name }}
                            </span>
                        </div>
                        <div class="uk-invisible">
                            <Button is-large has-action mode="theme">
                                <Icon icon="cart" />

                                <span class="uk-margin-small-left" />
                                <Translate translation-key="cart" />
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            <div :class="isGalleryPage ? 'uk-padding' : ''">
                <Card
                    mode="default"
                    :class="isGalleryPage ? 'site-struct single' : ''"
                    is-dark>
                    <div v-if="err">
                        <ModalTitle
                            is-dark
                            class="uk-text-center"
                            :title="$t('order.not.exist')" />

                        <InfoBox mode="primary">
                            <Translate
                                translation-key="order.not.exist.message" />
                        </InfoBox>

                        <div class="uk-margin-medium-top" />
                        <LinkObject :to="getLinkTo()">
                            <Button
                                :text="$t('order.to')"
                                is-large
                                is-max
                                mode="primary" />
                        </LinkObject>
                    </div>
                    <div v-else-if="paid">
                        <ModalTitle
                            is-dark
                            class="uk-text-center"
                            :title="$t('order.created.title')" />
                        <SuccessMessage without-animation success
                            >{{ $t(paidSuccessKey) }}
                        </SuccessMessage>

                        <div class="uk-margin-medium-bottom" />
                        <LinkObject :to="getLinkTo()">
                            <Button
                                :text="$t('order.more.pictures')"
                                is-large
                                is-max
                                mode="primary" />
                        </LinkObject>

                        <div v-if="!isApp">
                            <PWAPromptForm
                                v-if="getInfos && getInfos.name"
                                :name="getInfos.name"
                                :prompt-installer-event="
                                    promptInstallerEvent
                                " />
                            <PWAHintForm
                                v-if="getInfos && getInfos.name"
                                :name="getInfos.name" />
                        </div>
                    </div>
                    <div v-else-if="processingPayment">
                        <ModalTitle
                            is-dark
                            class="uk-text-center"
                            :title="$t('order.payment.processing')" />
                        <div
                            class="uk-flex uk-flex-center uk-margin-medium-top">
                            <div uk-spinner />
                        </div>
                    </div>
                    <div v-else-if="getInfos && getInfos.articles && !loading">
                        <ModalTitle
                            is-dark
                            class="uk-text-center"
                            :title="$t('order.payment.failed')" />
                        <InfoBox icon="warning" mode="warning">
                            <Translate
                                translation-key="order.payment.failed.message" />
                        </InfoBox>

                        <div v-if="order.gallery">
                            <div class="uk-margin-medium-top" />
                            <div class="section-title">{{ $t('gallery') }}</div>
                            <div>
                                {{ order.gallery.name }}
                            </div>
                        </div>

                        <div class="uk-margin-medium-top" />
                        <div class="section-title">{{ $t('pictures') }}</div>

                        <div
                            v-for="(item, originKey) in order.order.pictures"
                            :key="'p' + originKey"
                            class=""
                            uk-grid>
                            <div class="uk-width-medium@s uk-width-small">
                                <div
                                    class="uk-inline uk-transition-toggle image-struct"
                                    :style="{
                                        width:
                                            item.thumbnailCroppedWidth *
                                                getThumbnailDimensions(item)
                                                    .scale +
                                            'px',
                                        height:
                                            item.thumbnailCroppedHeight *
                                                getThumbnailDimensions(item)
                                                    .scale +
                                            'px',
                                        overflow: 'hidden',
                                        position: 'relative',
                                    }">
                                    <img
                                        :alt="order.files[item.id].FileName"
                                        :src="
                                            apiUrl +
                                            '/requests/' +
                                            order.order.requestId +
                                            '/thumbnails/' +
                                            order.files[item.id].FileName
                                        "
                                        :style="{
                                            position: 'absolute',
                                            top:
                                                '-' +
                                                item.thumbnailCroppedTop *
                                                    getThumbnailDimensions(item)
                                                        .scale +
                                                'px',
                                            left:
                                                '-' +
                                                item.thumbnailCroppedLeft *
                                                    getThumbnailDimensions(item)
                                                        .scale +
                                                'px',
                                            width:
                                                getThumbnailDimensions(item).w +
                                                'px',
                                            height:
                                                getThumbnailDimensions(item).h +
                                                'px',
                                            maxWidth: 'none',
                                            maxHeight: 'none',
                                        }" />
                                </div>
                            </div>
                            <div class="uk-width-expand">
                                <div
                                    class="uk-grid-small uk-child-width-1-1"
                                    uk-grid>
                                    <div class="uk-width-auto@s uk-width-1-1">
                                        <span class="uk-badge badge"
                                            >{{ item.amount }}x</span
                                        >
                                    </div>
                                    <div class="uk-width-auto@s uk-width-1-1">
                                        {{
                                            getFormatByArticleID(
                                                item.articleId,
                                                true
                                            )
                                        }}
                                        ({{
                                            getPriceByArticleID(
                                                item.articleId,
                                                item.amount
                                            )
                                        }}{{
                                            getArticleByID(item.articleId)
                                                .isHeightVariable
                                                ? ' ' +
                                                  $t('per.x', {
                                                      x: $t(
                                                          getInfos.measurementUnit
                                                      ),
                                                  })
                                                : ''
                                        }}{{
                                            getArticleByID(item.articleId)
                                                .isHeightVariable &&
                                            getArticleByID(item.articleId)
                                                .minPrice
                                                ? ', ' +
                                                  $t('min') +
                                                  ' ' +
                                                  getNumberWithCurrency(
                                                      getArticleByID(
                                                          item.articleId
                                                      ).minPrice
                                                  )
                                                : ''
                                        }})
                                    </div>

                                    <div v-if="isVariableHeight(originKey)">
                                        <div class="uk-grid-small" uk-grid>
                                            <div
                                                class="uk-width-expand"
                                                uk-leader>
                                                {{ $t('pictureLength') }}
                                                ({{
                                                    $t(
                                                        getPictureFormatName(
                                                            originKey
                                                        ) + '.format'
                                                    )
                                                }})
                                            </div>
                                            <div>
                                                <div
                                                    v-if="
                                                        item.measurementValue ===
                                                        0
                                                    "
                                                    uk-spinner />
                                                <span v-else>
                                                    {{
                                                        formatMeasurement(
                                                            item.measurementValue
                                                        )
                                                    }}
                                                    {{
                                                        $t(
                                                            getInfos.measurementUnit
                                                        )
                                                    }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="uk-grid-small" uk-grid>
                                            <div
                                                class="uk-width-expand"
                                                uk-leader>
                                                {{ $t('price') }}
                                            </div>
                                            <div>
                                                {{
                                                    getNumberWithCurrency(
                                                        getCostsByAmountAndArticleId(
                                                            item
                                                        )
                                                    )
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="uk-margin-medium-bottom" />
                        <div class="section-title">
                            {{ $t('contact.details') }}
                        </div>
                        <div>
                            {{ order.order.name }}
                        </div>
                        <div>
                            {{ order.order.email }}
                        </div>
                        <div>
                            {{ order.order.telephone }}
                        </div>

                        <div v-if="order.order.street">
                            <div>
                                {{ order.order.name }}
                            </div>
                            <div>
                                {{ order.order.zip }}
                            </div>
                            <div>
                                {{ order.order.city }}
                            </div>
                            <div>{{ $t(order.order.country) }}</div>
                        </div>

                        <div v-if="order.order.comments">
                            <div class="uk-margin-medium-bottom" />
                            <div class="section-title">
                                {{ $t('comments') }}
                            </div>
                            <div>
                                {{ order.order.comments }}
                            </div>
                        </div>

                        <div class="uk-margin-medium-bottom" />
                        <div class="section-title">
                            {{ $t('delivery.type') }}
                        </div>
                        <div>{{ $t(order.order.deliveryType) }}</div>

                        <div class="uk-margin-medium-bottom" />
                        <div class="section-title" id="payment-method">
                            {{ $t('payment.method') }}
                        </div>

                        <div
                            class="uk-margin-top"
                            v-if="paymentMethod === 'online'">
                            <stripe-element-payment
                                ref="paymentRef"
                                @element-ready="setPaymentRendered"
                                :pk="getInfos.stripe.key"
                                :elements-options="elementsOptions"
                                :confirm-params="confirmParams" />
                        </div>

                        <div class="uk-margin-medium-bottom" />
                        <div class="section-title">{{ $t('price') }}</div>

                        <div class="uk-grid-small" uk-grid>
                            <div class="uk-width-expand" uk-leader>
                                <span class="uk-badge badge">{{
                                    order.prices.totalPicturesCount
                                }}</span>
                                {{
                                    $t(
                                        order.prices.totalPicturesCount === 1
                                            ? 'picture'
                                            : 'pictures'
                                    )
                                }}
                            </div>
                            <div>
                                {{
                                    getNumberWithCurrency(
                                        order.prices.totalPicturesCost
                                    )
                                }}
                            </div>
                        </div>

                        <div class="uk-grid-small" uk-grid>
                            <div class="uk-width-expand" uk-leader>
                                {{ $t('service.fee') }}
                            </div>
                            <div>
                                {{ getNumberWithCurrency(order.prices.fee) }}
                            </div>
                        </div>

                        <div
                            class="uk-grid-small uk-margin-small-medium-top"
                            uk-grid>
                            <div class="uk-width-expand" uk-leader>
                                {{ $t('shipping.costs') }}
                            </div>
                            <div>
                                {{
                                    getNumberWithCurrency(
                                        order.prices.shippingCosts
                                    )
                                }}
                            </div>
                        </div>

                        <div
                            class="uk-grid-small uk-margin-small-medium-top total-costs-text"
                            uk-grid>
                            <div class="uk-width-expand" uk-leader>
                                {{ $t('total') }}
                            </div>
                            <div>
                                {{
                                    getNumberWithCurrency(
                                        order.prices.totalPrice
                                    )
                                }}
                            </div>
                        </div>
                        <div class="vat">
                            {{
                                $t('vat.message', {
                                    vat: getNumberFormatted(getInfos.vat),
                                })
                            }}
                        </div>

                        <div class="uk-margin-medium-top" />
                        <Button
                            :action="complete"
                            :is-loading="updateLoading || !paymentRendered"
                            :text="$t('paid.order')"
                            has-action
                            is-large
                            is-max
                            mode="success" />

                        <div
                            v-if="updateError"
                            class="uk-margin-medium-bottom" />
                        <ErrorMessage
                            :custom-errors="[
                                {code: 408, message: $t('session.timed.out')},
                            ]"
                            :error="updateError" />

                        <div
                            v-if="paymentError"
                            class="uk-margin-medium-bottom" />
                        <InfoBox
                            v-if="paymentError"
                            class="uk-animation-fade"
                            mode="danger">
                            <Translate translation-key="payment.denied.error" />
                        </InfoBox>

                        <div
                            v-if="updateSuccess"
                            class="uk-margin-medium-bottom" />
                        <SuccessMessage :success="updateSuccess">
                            {{ $t(paidSuccessKey) }}

                            <div class="uk-margin-medium-bottom" />
                            <Button
                                :action="reload"
                                :text="$t('order.more.pictures')"
                                has-action
                                is-large
                                is-max
                                mode="primary" />
                        </SuccessMessage>
                    </div>
                </Card>
            </div>
        </LoadingStruct>
    </div>
</template>

<script>
import LoadingStruct from '@/views/LoadingStruct.vue';
import Card from '@/components/generic/Card.vue';
import PWAHintForm from '@/components/PWAHintForm.vue';
import PWAPromptForm from '@/components/PWAPromptForm.vue';
import SuccessMessage from '@/components/generic/SuccessMessage.vue';
import Button from '@/components/generic/Button.vue';
import LinkObject from '@/components/LinkObject.vue';
import InfoBox from '@/components/generic/InfoBox.vue';
import Translate from '@/components/Translate.vue';
import axios from 'axios';
import Icon from '@/components/generic/Icon.vue';
import {StripeElementPayment} from '@vue-stripe/vue-stripe';
import ErrorMessage from '@/components/generic/ErrorMessage.vue';
import ModalTitle from '@/components/generic/ModalTitle.vue';

export default {
    name: 'Order',
    components: {
        ModalTitle,
        ErrorMessage,
        StripeElementPayment,
        Icon,
        Translate,
        InfoBox,
        LinkObject,
        Button,
        SuccessMessage,
        PWAPromptForm,
        PWAHintForm,
        Card,
        LoadingStruct,
    },
    computed: {
        // a terminal order may have no e-mail (MainTerminal's return_url)
        paidSuccessKey() {
            return this.$route.query.withoutemail
                ? 'order.created.message'
                : 'paid.order.success';
        },
    },
    created() {
        const paymentStatus = this.$route.query.redirect_status;

        if (paymentStatus === 'succeeded' || paymentStatus === 'processing') {
            this.paid = true;
            this.loading = false;
        } else if (paymentStatus === 'pending') {
            this.processingPayment = true;
            this.loading = false;
            this.pollIsPaid();
        } else {
            this.receiveIsPaid();
        }
    },
    mounted() {
        let self = this;

        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            self.isApp = false;
            self.promptInstallerEvent = e;
        });

        const ua = window.navigator.userAgent;
        const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
        const webkit = !!ua.match(/WebKit/i);
        const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
        if (iOSSafari && !navigator.standalone) {
            this.isApp = false;
        }
    },
    methods: {
        getThumbnailDimensions(item) {
            const file = this.order.files[item.id];

            let maxW = 436,
                maxH = 638;
            if (this.order.gallery) {
                maxW = 800;
                maxH = 600;
            }

            const ratio = Math.min(maxW / file.Width, maxH / file.Height);
            const displayScale = this.order.gallery
                ? Math.min(436 / maxW, 638 / maxH)
                : 1;

            return {
                w: file.Width * ratio * displayScale,
                h: file.Height * ratio * displayScale,
                scale: displayScale,
            };
        },
        getFormatByArticleID(articleId, isShort = false) {
            let article = this.getArticleByID(articleId);
            return (
                this.getPaperName(article.paper) +
                ' ' +
                this.getArticleFormat(article, isShort)
            );
        },
        getCostsByAmountAndArticleId(item) {
            let articleId = item.articleId;
            let amount = item.amount;

            let article = this.getArticleByID(articleId);
            let price = article.price;

            if (article.graduatedPrices) {
                let graduatedPrices = this.getSortedGraduatedPrices(
                    article.graduatedPrices
                );
                let picturesAmount =
                    this.getGroupedPicturesAmountByArticleID(articleId);

                for (let k = 0, l = graduatedPrices.length; k < l; k++) {
                    if (picturesAmount >= graduatedPrices[k].amount) {
                        price = graduatedPrices[k].price;
                    }
                }
            }

            if (article.isHeightVariable) {
                let measurementValue = item.measurementValue;
                let measurementValueRounded = Math.round(measurementValue);

                price = price * measurementValueRounded;

                price = Math.round(price * 10) / 10;

                if (article.minPrice && article.minPrice > price) {
                    price = article.minPrice;
                }
            }

            return amount * price;
        },
        getPictureFormatName(key) {
            let item = this.order.order.pictures[key];

            if (item.coordinates) {
                if (item.coordinates.height > item.coordinates.width) {
                    return 'vertical';
                }

                return 'horizontal';
            }

            if (item.height > item.width) {
                return 'vertical';
            }

            return 'horizontal';
        },
        isVariableHeight(key) {
            let item = this.order.order.pictures[key];
            let article = this.getArticleByID(item.articleId);

            return article.isHeightVariable;
        },
        getArticleByID(articleId) {
            if (this.order.gallery) {
                return this.getArticleByIDGallery(articleId);
            }

            const articles = this.getInfos.articles;
            for (let i = 0, j = articles.length; i < j; i++) {
                if (articles[i].id === articleId) {
                    return articles[i];
                }
            }
        },
        getArticleByIDGallery(articleID) {
            const articles = this.order.gallery.articleListID;
            for (let i = 0, j = articles.length; i < j; i++) {
                if (articles[i].id === articleID) {
                    return articles[i];
                }
            }
        },
        getPaperName(paper) {
            if (['matt', 'glossy'].includes(paper)) {
                return this.$t(paper);
            }

            return paper;
        },
        getArticleFormat(article) {
            if (article.name) {
                return article.name;
            }

            if (article.isHeightVariable) {
                return (
                    this.roundWidth(article.width) +
                    ' ' +
                    this.$t(this.getInfos.measurementUnit) +
                    ' x ' +
                    this.$t('pictureLength')
                );
            }

            return (
                this.roundWidth(article.width) +
                ' x ' +
                this.roundHeight(article.height) +
                ' ' +
                this.$t(this.getInfos.measurementUnit)
            );
        },
        roundWidth(width) {
            const integerPart = parseInt(width);
            const decimalPart = width - integerPart;

            if (decimalPart >= 0.6) {
                return Math.ceil(width);
            }

            return Math.floor(width);
        },
        roundHeight(height) {
            const integerPart = parseInt(height);
            const decimalPart = height - integerPart;

            if (decimalPart >= 0.6) {
                return Math.ceil(height);
            }

            return Math.floor(height);
        },
        getPriceByArticleID(articleId) {
            let article = this.getArticleByID(articleId);

            let price = article.price;
            if (article.graduatedPrices) {
                let graduatedPrices = this.getSortedGraduatedPrices(
                    article.graduatedPrices
                );
                let picturesAmount =
                    this.getGroupedPicturesAmountByArticleID(articleId);

                for (let k = 0, l = graduatedPrices.length; k < l; k++) {
                    if (picturesAmount >= graduatedPrices[k].amount) {
                        price = graduatedPrices[k].price;
                    }
                }
            }

            return this.getNumberWithCurrency(price);
        },
        getSortedGraduatedPrices(graduatedPrices, invert = false) {
            let graduatedPricesParsed = JSON.parse(
                JSON.stringify(graduatedPrices)
            );

            function sortNodes(a, b) {
                if (a.amount < b.amount) return -1;
                if (a.amount > b.amount) return 1;
                return 0;
            }

            function sortNodesInvert(a, b) {
                if (a.amount > b.amount) return -1;
                if (a.amount < b.amount) return 1;
                return 0;
            }

            if (invert) {
                return graduatedPricesParsed.sort(sortNodesInvert);
            }

            return graduatedPricesParsed.sort(sortNodes);
        },
        getGroupedPicturesAmountByArticleID(articleId) {
            let amount = 0;

            let pictures = this.order.order.pictures;
            for (let i = 0, j = pictures.length; i < j; i++) {
                if (pictures[i].articleId === articleId) {
                    amount += pictures[i].amount;
                }
            }

            return amount;
        },
        getLinkTo() {
            const galleryID = this.$route.params.gallery;
            if (galleryID) {
                const token = this.$route.query.token;

                if (token) {
                    return 'galleries/' + galleryID + '?token=' + token;
                }

                return 'galleries/' + galleryID;
            }

            return '';
        },
        setPaymentRendered() {
            this.paymentRendered = true;
        },
        async complete() {
            this.updateLoading = true;

            try {
                const result =
                    await this.$refs.paymentRef.stripe.confirmPayment({
                        elements: this.$refs.paymentRef.elements,
                        confirmParams: {
                            return_url:
                                window.location.href +
                                'orders/' +
                                this.requestToken +
                                '/',
                        },
                    });

                if (result.error) {
                    this.updateLoading = false;
                    this.$refs.paymentRef.focus();
                }
            } catch (e) {
                this.updateLoading = false;
                this.$refs.paymentRef.focus();
                this.paymentError = e;
            }
        },
        updateOrder() {
            let http = axios.create();
            http.put(
                this.apiUrl +
                    '/requests/' +
                    this.order.order.requestId +
                    '/payment-method',
                {
                    paymentMethod: this.paymentMethod,
                }
            )
                .then(() => {
                    this.updateError = null;
                    this.updateSuccess = true;
                    this.updateLoading = false;
                })
                .catch((e) => {
                    this.checkGenericError(e);
                    this.updateError = e;
                    this.updateSuccess = false;
                    this.updateLoading = false;
                });
        },
        pollIsPaid() {
            const orderID = this.$route.params.order;
            let http = axios.create();
            let attempts = 0;
            const maxAttempts = 24;

            const poll = () => {
                http.get(this.apiUrl + '/requests/' + orderID + '/paid')
                    .then((response) => {
                        if (response.data.paid) {
                            this.processingPayment = false;
                            this.paid = true;
                        } else if (++attempts < maxAttempts) {
                            setTimeout(poll, 5000);
                        } else {
                            this.processingPayment = false;
                            this.receiveOrder();
                        }
                    })
                    .catch((e) => {
                        this.checkGenericError(e);
                        this.processingPayment = false;
                        this.err = e;
                    });
            };

            poll();
        },
        receiveIsPaid() {
            const orderID = this.$route.params.order;

            let http = axios.create();
            http.get(this.apiUrl + '/requests/' + orderID + '/paid')
                .then((response) => {
                    this.paid = response.data.paid;

                    if (this.paid) {
                        this.loading = false;
                    } else {
                        this.receiveOrder();
                    }
                })
                .catch((e) => {
                    this.checkGenericError(e);
                    this.err = e;
                    this.loading = false;
                });
        },
        receiveOrder() {
            const orderID = this.$route.params.order;

            let http = axios.create();
            http.get(this.apiUrl + '/requests/' + orderID)
                .then((response) => {
                    this.order = response.data;
                    this.err = null;
                    this.loading = false;

                    this.paymentMethod = this.order.order.paymentMethod;
                    this.elementsOptions.clientSecret = this.order.paymentKey;
                    this.confirmParams.return_url =
                        window.location.href +
                        'orders/' +
                        this.order.order.requestId +
                        '/';
                })
                .catch((e) => {
                    this.checkGenericError(e);
                    this.err = e;
                    this.loading = false;
                });
        },
    },
    data() {
        return {
            paid: null,
            processingPayment: false,

            isApp: true,
            promptInstallerEvent: null,

            updateSuccess: false,
            updateLoading: false,
            updateError: null,

            paymentError: null,

            paymentRendered: false,

            paymentMethod: 'online',

            order: {
                gallery: {
                    id: '',
                    name: '',
                    thumbnail: '',
                    articleListID: [
                        {
                            id: '',
                            paper: '',
                            width: 0,
                            height: 0,
                            price: 0,
                            graduatedPrices: [
                                {
                                    amount: 0,
                                    price: 0,
                                },
                            ],
                            isFavorite: false,
                            isHeightVariable: false,
                            dpi: 0,
                            name: '',
                            isTerminal: false,
                        },
                    ],
                    folders: [
                        {
                            name: '',
                            thumbnail: '',
                            stats: {
                                pictures: 0,
                            },
                        },
                    ],
                    stats: {
                        picturesTotal: 0,
                        pictures: 0,
                        folders: 0,
                    },
                    disabled: false,
                    isCroppingDisabled: false,
                    isDownloadAllowed: false,
                },

                files: {
                    key: {
                        OriginName: '',
                        FileName: '',
                        Width: 0,
                        Height: 0,
                    },
                },
                order: {
                    requestId: '',
                    name: '',
                    email: '',
                    telephone: '',
                    paymentMethod: '',
                    deliveryType: '',
                    comments: '',
                    pictures: [
                        {
                            id: '',
                            articleId: '',
                            amount: 0,
                            sort: 0,
                            pictureCroppedHeight: 0,
                            pictureCroppedWidth: 0,
                            pictureCroppedTop: 0,
                            pictureCroppedLeft: 0,
                            thumbnailCroppedHeight: 0,
                            thumbnailCroppedWidth: 0,
                            thumbnailCroppedTop: 0,
                            thumbnailCroppedLeft: 0,
                        },
                    ],
                    language: '',
                    platform: '',
                    street: '',
                    zip: '',
                    city: '',
                    country: '',
                    galleryID: '',
                },
                paymentKey: '',

                prices: {
                    totalPicturesCost: 3,
                    totalPicturesCount: 1,
                    totalPrice: 4.01,
                    shippingCosts: 0,
                    fee: 1.01,
                },
            },

            loading: true,
            err: null,

            elementsOptions: {
                appearance: {
                    rules: {
                        '.Tab': {
                            boxShadow:
                                '0px 0px 0px rgba(0, 0, 0, 0.03), 0px 0px 0px rgba(18, 42, 66, 0.02)',
                        },
                    },
                    variables: {
                        colorPrimary: '#092633',
                        colorBackground: '#ffffff',
                        colorText: '#30313d',
                        colorDanger: '#df1b41',
                        borderRadius: '0px',
                        boxShadow:
                            '0px 0px 0px rgba(0, 0, 0, 0.03), 0px 0px 0px rgba(18, 42, 66, 0.02)',
                    },
                },
            },
            confirmParams: {},
        };
    },
};
</script>

<style lang="scss" scoped>
.badge {
    font-size: 16px;
    padding: 10px 15px;
    margin-top: -5px;
    margin-right: 5px;
}

.galleries-struct2 {
    background-color: $site-color;
}

.infos-name {
    margin-right: 5px;
}

.iname {
    font-size: 16px;
    color: $site-background !important;
}

.dark {
    color: $site-background !important;
}

.logo {
    height: 42px;
}

.logo-struct {
    height: 42px;
    padding-top: 15px;
    padding-bottom: 15px;
}

.empty-logo-struct {
    padding-top: 60px;
}

.total-struct {
    padding-top: 15px !important;
    padding-bottom: 15px !important;

    position: sticky;
    top: 0;
    z-index: 1000;
    background: #fff !important;

    backdrop-filter: saturate(180%) blur(20px);
    background-color: rgba(243, 246, 249, 0.1) !important;
}

.total-costs-text {
    font-weight: 500;
}

.border-radius-adjusted {
    border-radius: 0 !important;
}

.vat {
    font-size: 14px;
    margin-top: 15px;
}

.section-title {
    font-size: 18px;
    font-weight: 500;
    color: $site-background;
    margin-bottom: 10px;
}
</style>
